<template>
    <div id="animation">
        <div class="row examples">
            <div class="col-3">
                <div class="snippet" data-title=".dot-elastic">
                    <div class="stage">
                        <div class="dot-2"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-pulse">
                    <div class="stage">
                        <div class="dot-pulse"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-flashing">
                    <div class="stage">
                        <div class="dot-flashing"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-collision">
                    <div class="stage">
                        <div class="dot-collision"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-revolution">
                    <div class="stage">
                        <div class="dot-revolution"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-carousel">
                    <div class="stage">
                        <div class="dot-carousel"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-typing">
                    <div class="stage">
                        <div class="dot-1"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-windmill">
                    <div class="stage">
                        <div class="dot-windmill"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-bricks">
                    <div class="stage">
                        <div class="dot-bricks"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-floating">
                    <div class="stage">
                        <div class="dot-floating"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-fire">
                    <div class="stage">
                        <div class="dot-fire"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-spin">
                    <div class="stage">
                        <div class="dot-spin"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-falling">
                    <div class="stage">
                        <div class="dot-falling"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-stretching">
                    <div class="stage">
                        <div class="dot-stretching"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row examples">
            <div class="col-3">
                <div class="snippet" data-title=".dot-gathering">
                    <div class="stage filter-contrast">
                        <div class="dot-gathering"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-hourglass">
                    <div class="stage filter-contrast">
                        <div class="dot-hourglass"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-overtaking">
                    <div class="stage filter-contrast">
                        <div class="dot-overtaking"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-shuttle">
                    <div class="stage filter-contrast">
                        <div class="dot-shuttle"></div>
                    </div>
                </div>
            </div>
            <!--             <div class="col-3">
                <div class="snippet" data-title=".dot-bouncing">
                    <div class="stage">
                        <div class="dot-bouncing"></div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="snippet" data-title=".dot-rolling">
                    <div class="stage">
                        <div class="dot-rolling"></div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    name: 'animation',
    data() {
        return {

        }
    },
    components: {},
    computed: {

    },
    mounted() {
        this.$store.commit('setPage', '/animation')
        this.$store.commit('setIsPage', true)
    },
    methods: {

    },
}
</script>